import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = { class: "font-weight-bold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_DialogComponent = _resolveComponent("DialogComponent")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_breadcrumbs_item = _resolveComponent("v-breadcrumbs-item")!
  const _component_v_breadcrumbs = _resolveComponent("v-breadcrumbs")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!

  return (_openBlock(), _createBlock(_component_v_tooltip, { bottom: "" }, {
    activator: _withCtx(({ props }) => [
      _createElementVNode("section", _mergeProps({ class: "my-3 scope-header" }, props), [
        _createVNode(_component_DialogComponent, {
          modelValue: _ctx.showBackConfirm,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.showBackConfirm) = $event)),
          value: _ctx.showBackConfirm
        }, {
          header: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("titles.confirmMessage")), 1)
          ]),
          body: _withCtx(() => [
            _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.$t("messages.sureBack")), 1)
          ]),
          actions: _withCtx(() => [
            _createVNode(_component_v_btn, {
              class: "primary mx-1 white--text",
              onClick: _ctx.navigateUrl
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("buttons.confirm")), 1)
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_v_btn, {
              class: "secondary white--text",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showBackConfirm = false))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("buttons.cancel")), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue", "value"]),
        _createElementVNode("div", {
          class: "font-weight-bold px-3 scope clickable align-center",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.goToNavigateUrl && _ctx.goToNavigateUrl(...args)))
        }, [
          _createVNode(_component_v_icon, {
            class: _normalizeClass(_ctx.scopeIconStyle)
          }, {
            default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
              _createTextVNode("mdi-office-building", -1)
            ]))]),
            _: 1
          }, 8, ["class"]),
          (_ctx.courseName)
            ? (_openBlock(), _createBlock(_component_v_breadcrumbs, {
                key: 0,
                items: _ctx.breadcrumbItems,
                class: "px-0"
              }, {
                item: _withCtx(({ item }) => [
                  _createVNode(_component_v_breadcrumbs_item, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$utils.servertranslate(_ctx.course.ScopeName)) + " - " + _toDisplayString(item.title), 1)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 1
              }, 8, ["items"]))
            : _createCommentVNode("", true)
        ])
      ], 16)
    ]),
    default: _withCtx(() => [
      _createElementVNode("span", null, _toDisplayString(_ctx.$t("messages.CHANGE_SCOPE")), 1)
    ]),
    _: 1
  }))
}